import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GrubhubApiService } from '../../_services/grubhubApi.service';
import { UtilsService } from '../../_services/utils.service';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-grubhub-auth-router',
  template: '<div class="auth-loading"><p>Connecting Grubhub...</p></div>',
  styles: ['.auth-loading { display:flex; justify-content:center; align-items:center; height:100vh; }']
})
export class GrubhubAuthRouterComponent implements OnInit {

  constructor(
    private router: Router,
    private grubhubApi: GrubhubApiService,
    private utilsService: UtilsService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');

    if (!code) {
      this.alertService.error('Grubhub authorization failed — no code received');
      this.router.navigate(['/sidebar/admin/online-ordering']);
      return;
    }

    const user = this.utilsService.getCurrentUser();
    const orgUuid = user?.orgSettings?.orgUuid;

    if (!orgUuid) {
      this.alertService.error('No organization found');
      this.router.navigate(['/login']);
      return;
    }

    this.grubhubApi.authenticate(code, orgUuid).subscribe({
      next: () => {
        this.alertService.success('Grubhub connected successfully');
        this.router.navigate(['/sidebar/admin/online-ordering']);
      },
      error: (err) => {
        console.error('Grubhub auth error:', err);
        this.alertService.error('Failed to connect Grubhub');
        this.router.navigate(['/sidebar/admin/online-ordering']);
      }
    });
  }
}
